<div class="card card-stretch h-100 rounded-0 context-menu">
    <div class="card-header p-3 d-flex justify-content-between border-bottom-0">
        <h5 class="card-title mb-0 font-weight-bolder">
            <img src="../../../../assets/common/images/Activities/MydashboardProject.svg" class="h-20px w-20px mr-2" />   {{'MyProjects' |localize}}
        </h5>
        <div *ngIf="Loaded && !Empty"  class="ml-auto cursor-pointer card-toolbar">
            <div class="font-weight-bolder text-primary cursor-pointer" (click)="viewall()">
                {{ 'ViewAll' | localize}}
            </div>
        </div>
    </div>

    <div class="card-body p-0 pb-3">
        <!--Empty State UI Code-->

        <div *ngIf="Loaded && Empty">
            <div class="d-flex justify-content-center">
                <div class="d-flex flex-column mt-20">
                    <img src="../../../../assets/common/images/new-dashboard/project-empty-ui.svg" class="h-200px w-275px  ml-8" />
                    <h6 class="text-muted mt-4 ml-30">{{'NoDataFounds'|localize}}</h6>
                </div>
            </div>
        </div>

        <!--Shimmer Code-->
        <div *ngIf="!Loaded && Empty" class="row px-4">
            <div class="col-md-12">
                <app-dashboard-table-skeleton
                    [columnCount]="5"
                    [rows]="4"
                    [firstColMultiLine]="true">
                </app-dashboard-table-skeleton>
            </div>
        </div>

        <!--Project Section Code-->

        <div *ngIf="Loaded && !Empty">
            <div class="dashboard-project-content px-4" id="dashboard-project">
                <div id="dashBoard-Project-data-table" class="dashboard-project-table overflow-auto">
                    <p-table [value]="this.projectDetails" [rows]="5" [paginator]="false" styleClass="w-100">
                        <ng-template pTemplate="header">
                            <tr [ngClass]="'textcolor'">
                                <th>{{'ProjectName' |localize}}</th>
                                <th>{{'ProgressBar'|localize}}</th>
                                <th >{{'StartDate'|localize}}</th>
                                <th>{{'EndDate'|localize}}</th>
                                <th>{{'Status'|localize}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-ProjectDetailsDto>
                            <tr [ngClass]="'textcolor bg-hover-gray-100'" class="dashboard-project-row">
                                <td class="project-name-cell">
                                    <div class="d-flex ">
                                        <div class="d-flex align-items-center">

                                            <div>
                                                <img alt="Pic" *ngIf="ProjectDetailsDto.projectImage" [src]="ProjectDetailsDto.projectImage" class="h-30px  w-30px border border-light rounded" id="profimgsize" />
                                                <img alt="Pic" *ngIf="!ProjectDetailsDto.projectImage" src="assets/common/images/new-dashboard/default-project-bag.svg" class="h-30px  w-30px border border-light rounded" id="profimgsize" />
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column ml-3 justify-content-center" pTooltip="{{ProjectDetailsDto.projectName}}" [tooltipDisabled]="ProjectDetailsDto.projectName | tooltipDisabled:15" tooltipPosition="bottom">
                                            {{ProjectDetailsDto.projectName| slice:0:15}}{{ProjectDetailsDto.projectName.length > 15 ? '...' : '' }}
                                            <div class="font10" pTooltip="{{ProjectDetailsDto.clientName}}" [tooltipDisabled]="ProjectDetailsDto.clientName | tooltipDisabled:16" tooltipPosition="bottom">{{ProjectDetailsDto.clientName| slice:0:15}}{{ProjectDetailsDto.clientName > 15 ? '...' : '' }}</div>

                                        </div>

                                    </div>
                                </td>
                                <td class="project-progress-cell">
                                    <div class="project-progress-wrapper">
                                        <itp-progress-bar
                                            [value]="HoursLoggedBarCalculation(ProjectDetailsDto.projectStartDate, ProjectDetailsDto.projectEndDate)"
                                            [showLabel]="true">
                                        </itp-progress-bar>
                                    </div>
                                </td>
                                <td>
                                    {{ProjectDetailsDto.projectStartDate | dateFormat}}
                                </td>
                                <td>
                                    <div>

                                        {{ProjectDetailsDto.projectEndDate | dateFormat}}
                                    </div>

                                </td>
                                <td>

                                    <!--
                                   old ngClass
                                    [ngClass]="{'border-warning': ProjectDetailsDto.projectStatus == 2,'border-success': ProjectDetailsDto.projectStatus == 3,'border-primary': ProjectDetailsDto.projectStatus == 1,'w-80px':ProjectDetailsDto.projectStatus == 3,'w-70px':ProjectDetailsDto.projectStatus == 2,'w-50px':ProjectDetailsDto.projectStatus == 4}"
                                -->
                                    <span class="label label-outline-secondary rounded-pill h-28px label-inline border  bg-white" [ngClass]="{'status-width':ProjectDetailsDto.projectStatus == 3}">
                                        <span class="span-allign-center text-center mx-auto">
                                            <span class="label label-dot" [ngClass]="{'label-primary':ProjectDetailsDto.projectStatus == 1,'label-info':ProjectDetailsDto.projectStatus == 2,'label-success':ProjectDetailsDto.projectStatus == 3,'label-danger':ProjectDetailsDto.projectStatus == 4}"></span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 1" class="ml-2">{{'New'|localize}}</span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 2" class="ml-2">{{'Active'| localize}}</span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 3" class="ml-2">{{'Complete'|localize}}</span>
                                            <span *ngIf="ProjectDetailsDto.projectStatus == 4" class="ml-2">{{'Closed'|localize}}</span>
                                        </span>

                                    </span>

                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                    <div class="primeng-paging-container ml-auto">
                        <p-paginator [rows]="4"
                                     #paginator
                                     [alwaysShow]="false"
                                     [showJumpToPageDropdown]="false">
                        </p-paginator>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
